module.exports = __webpack_public_path__ + "img/Angiogenesis-SCC_GSE144240.f7ebbf15.png";